import React, { useEffect, useState, useCallback, useRef } from "react";
import GmapImg from "../../../assets/provider/images/Google_Map.svg";
import PdfImg from "../../../assets/user/images/document-text.svg";
import careuserprofile from "../../../assets/provider/images/user.png";
import caresuccessful from "../../../assets/provider/images/successful.svg";
import deleteaccountImg from "../../../assets/user/images/delete-account.svg";
import LocImg from "../../../assets/user/images/location.svg";
import StarImg from "../../../assets/provider/images/starwh.svg";
import TrashImg from "../../../assets/user/images/trash.svg";
import FileImg from "../../../assets/provider/images/file.jpg";
import { api } from "../../../utlis/staff/api.utlis";
import ApiService from "../../../core/services/ApiService";
import Loader from "../../../layouts/loader/Loader";
import NoImage from "../../../assets/admin/images/no-image.jpg";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { userLogout } from "../../../store/slices/Auth";
import { routes } from "../../../utlis/staff/routes.utlis";
import { useJsApiLoader, StandaloneSearchBox } from "@react-google-maps/api";
import { updateProfileData } from "../../../store/slices/Profile";
import InputMask from "react-input-mask";
import {
  GeolocationApiKey,
  LogoFile,
  milesOptions,
  MultipleFile,
  SingleFile,
} from "../../../utlis/common.utlis";
import moment from "moment";

const Page = () => {
  const imgs = [];
  const inputRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState();
  const [deleteAcc, setDeleteAcc] = useState(false);
  const [file, setFile] = useState();
  const [edit, setEdit] = useState({ status: false, id: null });
  const [editImg, setEditImg] = useState(false);
  const [state, setState] = useState([]);
  const [selectedState, setSelectedState] = useState([]);
  const [stateError, setStateError] = useState(false);
  const [city, setCity] = useState([]);
  const [selectedCity, setSelectedCity] = useState([]);
  const [cityError, setCityError] = useState(false);
  const [categories, setCategory] = useState([]);
  const [subCategories, setSubCategory] = useState([]);
  const [selectRadius, setSelectRadius] = useState("");
  const [selectCategories, setSelectCategory] = useState("");
  const [selectSubCategories, setSelectSubCategory] = useState("");
  const [multiFile, setMultiFile] = useState([]);
  const [selectedImages, setSelectedImages] = useState([]);
  const [selectedLicenseImages, setSelectedLicenseImages] = useState([]);
  const [selectedDeleteImages, setSelectedDeleteImages] = useState([]);
  const [imgError, setImgError] = useState(false);
  const [imgMultiError, setImgMultiError] = useState(false);
  const [location, setLocation] = useState({
    lat: null,
    lng: null,
    address: null,
  });

  const getMyProfile = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    if (response.data.status && response.data.statusCode === 200) {
      setSelectCategory(response?.data?.data?.categoryid);
      getSubCategoryList(response?.data?.data?.categoryid);
      setLocation({
        lat: response?.data?.data?.latitude,
        lng: response?.data?.data?.longitude,
        address: response?.data?.data?.business_address,
      });
      setDetails(response.data.data);
      dispatch(updateProfileData(response.data.data));
      response?.data?.data?.license_images.forEach((element) => {
        imgs.push({
          file: element,
          isLive: true,
          preview: element.url,
        });
      });
      setSelectedLicenseImages(imgs);
    } else setDetails();
    setLoading(false);
  };

  const deleteAccount = async () => {
    setLoading(true);
    const response = await ApiService.deleteAPIWithAccessToken(
      api.deleteAccount
    );
    setDeleteAcc(false);
    if (response.data.status) {
      toast.success(response.data.message);
      signOut();
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const signOut = useCallback(() => {
    dispatch(userLogout());
  }, [dispatch]);

  const getCategoryList = async (api) => {
    const response = await ApiService.getAPI(api);
    // console.log("category list => ", response.data);
    if (response.data.status && response.data.statusCode === 200) {
      setCategory(response.data.data.categories);
    } else setCategory([]);
  };

  const getSubCategoryList = async (id) => {
    const response = await ApiService.getAPI(
      api.categoryList + `?categoryid=${id}`
    );
    // console.log("sub category list => ", response.data);
    if (response?.data?.status && response?.data?.statusCode === 200) {
      setSubCategory(response?.data?.data?.categories);
    } else setSubCategory([]);
  };

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: GeolocationApiKey,
    libraries: ["places"],
  });

  const handlePlaceChange = () => {
    let [address] = inputRef.current.getPlaces();
    // console.log(findStateCity('administrative_area_level_1', address.address_components));
    // console.log(findStateCity('locality', address.address_components));
    setLocation({
      lat: address.geometry.location.lat(),
      lng: address.geometry.location.lng(),
      address: address.formatted_address,
    });
  };

  const initialValues = {
    radius: details?.service_offered_area ?? "",
    sub_category: details?.service_id ?? "",
    name: details?.fullname ?? "",
    phone: details?.mobile ?? "",
    free_in_home_assessment:
      details?.free_in_home_assessment != null &&
      details?.free_in_home_assessment != undefined &&
      details?.free_in_home_assessment != ""
        ? details?.free_in_home_assessment.toString()
        : "",
    fee_per_week: details?.fee_per_week ?? "",
    fee_per_month: details?.fee_per_month ?? "",
    fee_per_hour: details?.fee_per_hour ?? "",
    business_name: details?.business_name ?? "",
    care_job_title: details?.care_job_title ?? "",
    gender: details?.gender ?? "",
    license_number: details?.license_number ?? "",
    payment_accepted_type: details?.payment_accepted_type ?? "",
    response_time: details?.response_time ?? "",
    description: details?.description ?? "",
    experience: details?.experience ?? "",
    resume: "",
    files: [],
  };

  const initialValuesImg = {
    image: "",
  };

  const validationSchema = Yup.object().shape({
    radius: Yup.string().required("Radius is required!"),
    sub_category: Yup.string().required("Sub Category is required!"),
    name: Yup.string().required("Name is required!"),
    phone: Yup.string()
      .min(14, "Phone is invalid")
      .required("Phone is required!"),
    free_in_home_assessment: Yup.string().required(
      "In-Home assessment is required!"
    ),
    gender: Yup.string().required("Gender is required!"),
    business_name: Yup.string().required("Business name is required!"),
    care_job_title: Yup.string().required("Care job title is required!"),
    license_number: Yup.string()
      .matches(/^[A-Z0-9-]+$/, "Invalid license number format")
      .min(5, "License number must be at least 5 characters")
      .max(15, "License number must not exceed 15 characters")
      .required("License number is required!"),
    payment_accepted_type: Yup.string().required("Payment type is required!"),
    response_time: Yup.string().required("Payment type is required!"),
    description: Yup.string().required("Description is required!"),
    experience: Yup.string().required("Experience is required!"),
    resume: Yup.mixed()
      .test("fileSize", "File size is too large", (value) => {
        return value != "" && (value != null) & (value != undefined)
          ? value.size <= SingleFile * 1024 * 1024
          : true;
      })
      .test("fileType", "Unsupported file type", (value) => {
        return value != "" && (value != null) & (value != undefined)
          ? [
              "application/pdf",
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            ].includes(value.type)
          : true;
      }),
    files: Yup.array()
      .max(3, "You can upload a maximum of 3 images")
      .test("fileType", "Unsupported file type", (files) =>
        files.every((file) =>
          file.file != "" && (file.file != null) & (file.file != undefined)
            ? [
                "image/jpeg",
                "image/png",
                "image/jpg",
                "application/pdf",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
              ].includes(file.file.type)
            : true
        )
      )
      .test("fileSize", "File size is too large", (files) =>
        files.every((file) =>
          file.file != "" && (file.file != null) & (file.file != undefined)
            ? file.file.size <= MultipleFile * 1024 * 1024
            : true
        )
      ),
  });

  const validationSchemaImg = Yup.object().shape({
    image: Yup.mixed()
      .required("Please upload your profile image")
      .test("fileSize", "File size is too large", (value) => {
        return value && value.size <= LogoFile * 1024 * 1024;
      })
      .test("fileType", "Unsupported file type", (value) => {
        return (
          value && ["image/jpeg", "image/png", "image/jpg"].includes(value.type)
        );
      }),
  });

  const updateProfile = async (formValue) => {
    setLoading(true);
    let form = new FormData();
    form.append("service_id", formValue.sub_category);
    form.append("fullname", formValue.name);
    form.append("phone", formValue.phone);
    form.append("description", formValue.description);
    form.append("fee_per_hour", formValue.fee_per_hour);
    form.append("fee_per_month", formValue.fee_per_month);
    form.append("fee_per_week", formValue.fee_per_week);
    form.append("experience", formValue.experience);
    form.append("business_name", formValue.business_name);
    form.append("care_job_title", formValue.care_job_title);
    form.append("gender", formValue.gender);
    form.append("license_number", formValue.license_number);
    form.append("free_in_home_assessment", formValue.free_in_home_assessment);
    form.append("user_type", 3);
    form.append("service_offered_area", formValue.radius);
    form.append("payment_accepted_type", formValue.payment_accepted_type);
    form.append("response_time", formValue.response_time);
    form.append("business_address", location.address);
    form.append("latitude", location.lat);
    form.append("longitude", location.lng);
    if (formValue.files.length !== 0) {
      formValue.files.forEach((image) => {
        if (!image.isLive) form.append("license_image", image.file);
      });
    }
    if (selectedDeleteImages.length !== 0) {
      selectedDeleteImages.forEach((ele) => {
        form.append("deleteimageid[]", ele);
      });
    }
    if (
      formValue.resume !== "" &&
      formValue.resume !== null &&
      formValue.resume
    ) {
      form.append("resume", formValue.resume);
    }
    const response = await ApiService.putAPIWithAccessTokenMultiPart(
      api.updateProfile + edit.id,
      form
    );
    setSelectedImages([]);
    setSelectedDeleteImages([]);
    setSelectedLicenseImages([]);
    setEdit({
      status: false,
      id: null,
    });
    if (response.data.status) {
      toast.success(response.data.message);
      getMyProfile(api.profile);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const updateProfileImg = async (formvalue) => {
    setLoading(true);
    let form = new FormData();
    form.append("image", formvalue.image);
    const response = await ApiService.postAPIWithAccessTokenMultiPart(
      api.updateProfileImage,
      form
    );
    setEditImg(false);
    if (response.data.status) {
      toast.success(response.data.message);
      getMyProfile(api.profile);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const handleFileChange = (event, setFieldValue) => {
    const files = Array.from(event.target.files);
    if (files.length + selectedImages.length > 3) {
      alert("You can upload a maximum of 3 files.");
      return;
    }
    const imageUrls = files.map((file) => ({
      file,
      isLive: false,
      preview: URL.createObjectURL(file),
    }));
    setSelectedImages((prev) => [...prev, ...imageUrls]);
    setFieldValue("files", [...selectedImages, ...imageUrls]);
  };

  const removeImage = (index, setFieldValue, id = null) => {
    if (id != null) {
      const updatedLicenseImages = selectedLicenseImages.filter(
        (_, i) => i !== index
      );
      setSelectedLicenseImages(updatedLicenseImages);
      setSelectedDeleteImages((prev) => [...prev, id]);
    } else {
      const updatedImages = selectedImages.filter((_, i) => i !== index);
      setSelectedImages(updatedImages);
      setFieldValue("files", updatedImages);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getMyProfile(api.profile);
    getCategoryList(api.categoryList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="container">
        <div className="messages-section">
          <div className="row">
            <div className="col-md-12">
              <div className="care-title-header">
                <div className="care-title-header-1">
                  <h6 className="heading-name-title text-capitalize p-0">
                    Hello,{" "}
                    {details?.business_name
                      ? details?.business_name
                      : details?.fullname}
                  </h6>
                  <h2 className="heading-title">Your Profile Looks Great !</h2>
                </div>
                <div>
                  <div className="">
                    <Link
                      class="btn-re"
                      onClick={() => setDeleteAcc(true)}
                      to=""
                    >
                      <i className="fa fa-trash ms-2"></i> Delete Account
                    </Link>
                  </div>
                </div>
              </div>
              <div className="providerProfile-section">
                <div className="user-table-item">
                  <div className="row g-1 align-items-center">
                    <div className="col-md-8">
                      <div className="user-profile-item">
                        <div
                          className="user-profile-media"
                          style={{
                            position: "relative",
                            width: "100px",
                            height: "100px",
                            borderRadius: "0",
                            border: "none",
                          }}
                        >
                          {details?.profile_image !== null &&
                          details?.profile_image !== "" &&
                          details?.profile_image !== undefined ? (
                            <img
                              src={details?.profile_image}
                              style={{
                                borderRadius: "50%",
                              }}
                              alt=""
                            />
                          ) : (
                            <img
                              src={NoImage}
                              alt=""
                              style={{
                                borderRadius: "50%",
                              }}
                            />
                          )}
                          <div
                            className="p-image"
                            onClick={() => setEditImg(true)}
                          >
                            <i className="fa fa-pencil"></i>
                          </div>
                        </div>
                        <div className="user-profile-text">
                          <h2 className="text-capitalize">
                            {details?.fullname ?? "NA"}
                          </h2>
                          <div className="d-flex">
                            <div className="email-text text-lowercase">
                              <i className="fa fa-envelope ms-2"></i>{" "}
                              {details?.email ?? "NA"}
                            </div>
                            <div className="email-text ms-3">
                              <i className="fa fa-phone ms-2"></i>{" "}
                              {details?.mobile}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="user-profile-action">
                        <Link
                          className="btn-gr"
                          onClick={() =>
                            setEdit({ status: true, id: details?.id })
                          }
                        >
                          <i class="fa fa-edit ms-2"></i> Edit Profile
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="providerprofile-overview">
                  <div className="row g-3">
                    <div className="col-md-4">
                      <div className="overview-card">
                        <div className="overview-content">
                          <h2>Category</h2>
                          <h4 style={{ fontSize: "0.9rem" }}>
                            {details?.category ?? 0}
                          </h4>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="overview-card">
                        <div className="overview-content">
                          <h2>Sub Category</h2>
                          <h4 style={{ fontSize: "0.9rem" }}>
                            {details?.subcategory ?? 0}
                          </h4>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="overview-card">
                        <div className="overview-content">
                          <h2>Service Offered Area</h2>
                          <h4 style={{ fontSize: "0.9rem" }}>
                            {details?.service_offered_area ?? 0} Miles
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="providerprofile-overview">
                  <div className="row g-3">
                    <div className="col-md-4">
                      <div className="overview-card">
                        <div className="overview-content">
                          <h2>Ongoing Jobs</h2>
                          <h4>
                            <Link
                              to=""
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(routes.myJobs, {
                                  state: {
                                    tab: 2,
                                  },
                                });
                              }}
                            >
                              {details?.activeJob ?? 0}
                            </Link>
                          </h4>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="overview-card">
                        <div className="overview-content">
                          <h2>Pending Request</h2>
                          <h4>
                            <Link
                              to=""
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(routes.myJobs, {
                                  state: {
                                    tab: 1,
                                  },
                                });
                              }}
                            >
                              {details?.pendingJob ?? 0}
                            </Link>
                          </h4>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="overview-card">
                        <div className="overview-content">
                          <h2>Cancelled Jobs</h2>
                          <h4>
                            <Link
                              to=""
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(routes.myJobs, {
                                  state: {
                                    tab: 3,
                                  },
                                });
                              }}
                            >
                              {details?.cancellJob ?? 0}
                            </Link>
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="providerprofile-overview">
                  <div className="row g-3">
                    <div className="col-md-4">
                      <div className="overview-card">
                        <div className="overview-content">
                          <h2>Repeat Client</h2>
                          <h4>{details?.repeatClient ?? 0}</h4>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="overview-card">
                        <div className="overview-content">
                          <h2>Response Rate</h2>
                          <h4>{details?.responseRate ?? 0}</h4>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="overview-card">
                        <div className="overview-content">
                          <h2>Response Time</h2>
                          <h4>{details?.response_time ?? 0}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="Address-card">
                  <div className="row mt-3">
                    <div className="care-location-text col-md-4">
                      <h4>Payment Types Accepted</h4>
                      <p>{details?.payment_accepted_type ?? "NA"}</p>
                    </div>
                    <div className="care-location-text col-md-4">
                      <h4>Experience </h4>
                      <p>{details?.experience ?? 0} Years</p>
                    </div>
                    <div className="care-location-text col-md-4">
                      <h4>Care Job Title </h4>
                      <p>{details?.care_job_title ?? "NA"}</p>
                    </div>
                  </div>
                  <div className="divider col-md-12"></div>
                  <div className="row mt-3">
                    <div className="care-location-text col-md-4">
                      <h4>Fees Per Hour</h4>
                      <p>
                        {details?.currency ?? "$"}
                        {details?.fee_per_hour ?? "0"}
                      </p>
                    </div>
                    <div className="care-location-text col-md-4">
                      <h4>Fees Per Week</h4>
                      <p>
                        {details?.currency ?? "$"}
                        {details?.fee_per_week ?? "0"}
                      </p>
                    </div>
                    <div className="care-location-text col-md-4">
                      <h4>Fees Per Month</h4>
                      <p>
                        {details?.currency ?? "$"}
                        {details?.fee_per_month ?? "0"}
                      </p>
                    </div>
                  </div>
                  <div className="divider col-md-12"></div>
                  <div className="care-location-text">
                    <h4>Services Description</h4>
                    <p>{details?.description ?? "NA"}</p>
                  </div>
                  <div className="divider col-md-12"></div>
                  <div className="care-location-text mb-2">
                    <h4>Service Area</h4>
                  </div>
                  <div className="full-address-detail">
                    <img src={GmapImg} alt="" />
                    <h6>{details?.business_address ?? "NA"}</h6>
                  </div>
                  {details?.resume != null &&
                  details?.resume != undefined &&
                  details?.resume != "" ? (
                    <>
                      <div className="divider col-md-12"></div>
                      <div className="care-location-text mb-2">
                        <h4>Resume/CV</h4>
                      </div>
                      <div className="full-address-detail">
                        <a href={details?.resume} target="_blank">
                          <img src={PdfImg} alt="" />
                        </a>
                      </div>
                    </>
                  ) : null}
                </div>

                {details?.license_images?.length != 0 ? (
                  <div className="Address-card">
                    <div className="row mt-3">
                      <div className="care-location-text col-md-4">
                        <h4>License Image/File</h4>
                      </div>
                    </div>
                    <div className="row p-3">
                      {details?.license_images?.map((ele, indx) => {
                        return (
                          <div
                            key={indx}
                            className="col-md-1 d-flex flex-column align-items-center"
                          >
                            <div>
                              <Link to={ele.url} target="_blank">
                                <img
                                  style={{
                                    maxWidth: "80px",
                                    maxHeight: "80px",
                                  }}
                                  src={FileImg}
                                  alt=""
                                />
                              </Link>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={edit.status}
        onHide={() => {
          setEdit({
            status: false,
            id: null,
          });
        }}
        className="modal-lg"
      >
        <div className="modal-content">
          <ModalHeader>
            <h5 className="mb-0">Edit Profile</h5>
          </ModalHeader>
          <ModalBody className="">
            <div className="add-items d-flex row findcare-form">
              <Formik
                initialValues={initialValues}
                validateOnChange={true}
                validationSchema={validationSchema}
                onSubmit={updateProfile}
                enableReinitialize
              >
                {({ values, setFieldValue }) => (
                  <Form id="first-step-form">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <h4>Name</h4>
                          <Field
                            type="text"
                            className="form-control"
                            name="name"
                            placeholder="Enter Name"
                          />
                          <ErrorMessage
                            name="name"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <h4>Email Address</h4>
                          <input
                            type="text"
                            className="form-control todo-list-input"
                            name="email"
                            value={details?.email}
                            disabled
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <h4>Phone</h4>
                          <Field name="phone">
                            {({ field }) => (
                              <InputMask
                                {...field}
                                mask="(999) 999-9999"
                                className="form-control"
                                maskChar=""
                                onChange={(e) => {
                                  setFieldValue(field.name, e.target.value);
                                }}
                                placeholder="Enter phone"
                              />
                            )}
                          </Field>
                          <ErrorMessage
                            name="phone"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group search-form-group">
                          <h4>Service Area</h4>
                          {isLoaded && (
                            <StandaloneSearchBox
                              onLoad={(ref) => (inputRef.current = ref)}
                              onPlacesChanged={handlePlaceChange}
                            >
                              <input
                                className="form-control"
                                placeholder="Enter Service Area"
                                defaultValue={location.address}
                              />
                            </StandaloneSearchBox>
                          )}
                          <span className="form-group-icon">
                            <img src={GmapImg} />
                          </span>
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="form-group">
                          <h4>Search By Miles Away</h4>
                          <div className="choosemiles-list">
                            <ul>
                              {milesOptions.map((ele, indx) => {
                                return (
                                  <li key={indx}>
                                    <div className="ceradio1">
                                      <Field
                                        type="radio"
                                        name="radius"
                                        id={`${ele.value}miles`}
                                        value={ele.value}
                                      />
                                      <label for={`${ele.value}miles`}>
                                        <span className="checkbox-text">
                                          <img src={LocImg} /> {ele.label}{" "}
                                        </span>
                                      </label>
                                    </div>
                                  </li>
                                );
                              })}
                            </ul>
                            <ErrorMessage
                              name="radius"
                              component="div"
                              className="alert alert-danger"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="form-group">
                          <h4>Gender</h4>
                          <div className="choosemiles-list">
                            <ul>
                              <li>
                                <div className="ceradio">
                                  <Field
                                    type="radio"
                                    name="gender"
                                    id="Male"
                                    value="M"
                                  />
                                  <label for="Male">
                                    <span className="checkbox-text"> Male</span>
                                  </label>
                                </div>
                              </li>
                              <li>
                                <div className="ceradio">
                                  <Field
                                    type="radio"
                                    name="gender"
                                    id="Female"
                                    value="F"
                                  />
                                  <label for="Female">
                                    <span className="checkbox-text">
                                      Female
                                    </span>
                                  </label>
                                </div>
                              </li>
                            </ul>
                            <ErrorMessage
                              name="gender"
                              component="div"
                              className="alert alert-danger"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="form-group">
                          <h4>Category</h4>
                          <div className="row">
                            <div className="col-md-12">
                              <select
                                className="form-control"
                                name="category"
                                defaultValue={selectCategories}
                                onChange={(e) => {
                                  getSubCategoryList(e.target.value);
                                  setSelectCategory(e.target.value);
                                }}
                              >
                                <option value="">Select Category</option>
                                {categories.length !== 0
                                  ? categories.map((ele, indx) => {
                                      return (
                                        <option key={indx} value={ele.id}>
                                          {ele.name ?? "NA"}
                                        </option>
                                      );
                                    })
                                  : null}
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="form-group">
                          <h4>Sub Category</h4>
                          <div className="row">
                            <div className="col-md-12">
                              <Field
                                as="select"
                                type="text"
                                className="form-control"
                                name="sub_category"
                              >
                                <option value="">Select Sub Category</option>
                                {subCategories.length !== 0
                                  ? subCategories.map((ele, indx) => {
                                      return (
                                        <option key={indx} value={ele.id}>
                                          {ele.name ?? "NA"}
                                        </option>
                                      );
                                    })
                                  : null}
                              </Field>
                              <ErrorMessage
                                name="sub_category"
                                component="div"
                                className="alert alert-danger"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <h4>Care Job Title</h4>
                          <Field
                            as="select"
                            type="text"
                            className="form-control"
                            name="care_job_title"
                          >
                            <option value="">Select Care Job Title</option>
                            <option value="Caregiver">Caregiver</option>
                            <option value="Nursing Assistant (NA)">
                              Nursing Assistant (NA)
                            </option>
                            <option value="Home Health Aide (CNA/HHA)">
                              Home Health Aide (CNA/HHA)
                            </option>
                            <option value="Medical Assistant (MA)">
                              Medical Assistant (MA)
                            </option>
                            <option value="Licensed Practical/Vocational Nurse (LPN/LVN)">
                              Licensed Practical/Vocational Nurse (LPN/LVN)
                            </option>
                            <option value="Registered Nurse (RN)">
                              Registered Nurse (RN)
                            </option>
                            <option value="Nurse Practitioner (NP)">
                              Nurse Practitioner (NP)
                            </option>
                          </Field>
                          <ErrorMessage
                            name="care_job_title"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <h4>Business Name</h4>
                          <Field
                            type="text"
                            className="form-control"
                            name="business_name"
                            placeholder="Enter Business Name"
                          />
                          <ErrorMessage
                            name="business_name"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <h4>
                            Experience{" "}
                            <span
                              className="text-danger"
                              style={{ fontSize: "0.7rem" }}
                            >
                              (In Years)
                            </span>
                          </h4>
                          <Field
                            type="text"
                            className="form-control"
                            name="experience"
                            placeholder="Enter Experience (In Years)"
                          />
                          <ErrorMessage
                            name="experience"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <h4>Free In-Home Assessment Offered?</h4>
                          <div className="choosemiles-list">
                            <ul>
                              <li>
                                <div className="ceradio">
                                  <Field
                                    type="radio"
                                    name="free_in_home_assessment"
                                    id="Yes"
                                    value="1"
                                  />
                                  <label for="Yes">
                                    <span className="checkbox-text"> Yes</span>
                                  </label>
                                </div>
                              </li>
                              <li>
                                <div className="ceradio">
                                  <Field
                                    type="radio"
                                    name="free_in_home_assessment"
                                    id="No"
                                    value="0"
                                  />
                                  <label for="No">
                                    <span className="checkbox-text">No</span>
                                  </label>
                                </div>
                              </li>
                            </ul>
                            <ErrorMessage
                              name="free_in_home_assessment"
                              component="div"
                              className="alert alert-danger"
                            />
                          </div>
                        </div>
                      </div>

                      <div class="col-md-4">
                        <div class="form-group search-form-group-r PerHour-form-group">
                          <h4>Fees Per Hour</h4>
                          <Field
                            type="number"
                            className="form-control"
                            name="fee_per_hour"
                            placeholder="Enter Fees"
                          />
                          <ErrorMessage
                            name="fee_per_hour"
                            component="div"
                            className="alert alert-danger"
                          />
                          <span class="dollar-text">$</span>
                          <span class="Rangedays-text">/Hour</span>
                        </div>
                      </div>

                      <div class="col-md-4">
                        <div class="form-group search-form-group-r PerHour-form-group">
                          <h4>Fees Per Week</h4>
                          <Field
                            type="number"
                            className="form-control"
                            name="fee_per_week"
                            placeholder="Enter Fees"
                          />
                          <ErrorMessage
                            name="fee_per_week"
                            component="div"
                            className="alert alert-danger"
                          />
                          <span class="dollar-text">$</span>
                          <span class="Rangedays-text">/Week</span>
                        </div>
                      </div>

                      <div class="col-md-4">
                        <div class="form-group search-form-group-r PerHour-form-group">
                          <h4>Fees Per Month</h4>
                          <Field
                            type="number"
                            className="form-control"
                            name="fee_per_month"
                            placeholder="Enter Fees"
                          />
                          <ErrorMessage
                            name="fee_per_month"
                            component="div"
                            className="alert alert-danger"
                          />
                          <span class="dollar-text">$</span>
                          <span class="Rangedays-text">/Month</span>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <h4>Response Time</h4>
                          <Field
                            as="select"
                            type="text"
                            className="form-control"
                            name="response_time"
                          >
                            <option value="">Select Response Time</option>
                            <option value="30 Minute">30 Minute</option>
                            <option value="1 Hour">1 Hour</option>
                            <option value="2 Hours">2 Hours</option>
                            <option value="3 Hours">3 Hours</option>
                            <option value="5 Hours">5 Hours</option>
                          </Field>
                          <ErrorMessage
                            name="response_time"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <h4>License Number</h4>
                          <Field
                            type="number"
                            className="form-control"
                            name="license_number"
                            placeholder="Enter License Number"
                          />
                          <ErrorMessage
                            name="license_number"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="form-group">
                          <h4>
                            Resume/CV{" "}
                            <span
                              className="text-danger"
                              style={{ fontSize: "0.7rem" }}
                            >
                              (In PDF & DOCX)
                            </span>
                          </h4>
                          <Field name="resume">
                            {({ field, form }) => (
                              <input
                                type="file"
                                accept=".docx, .pdf"
                                className="form-control"
                                onChange={(event) =>
                                  setFieldValue(
                                    "resume",
                                    event.currentTarget.files[0]
                                  )
                                }
                              />
                            )}
                          </Field>
                          <ErrorMessage
                            name="resume"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="form-group">
                          <h4>
                            License Image/File{" "}
                            <span
                              className="text-danger"
                              style={{ fontSize: "0.7rem" }}
                            >
                              (In JPG, JPEG, PNG, PDF & DOCX)
                            </span>
                          </h4>
                          <Field name="files">
                            {({ field, form }) => (
                              <div>
                                <input
                                  type="file"
                                  multiple
                                  accept="image/jpg, image/jpeg, image/png, application/pdf, .docx"
                                  className="form-control"
                                  onChange={(event) =>
                                    handleFileChange(event, setFieldValue)
                                  }
                                />
                              </div>
                            )}
                          </Field>
                          <ErrorMessage
                            name="files"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                        <div className="row mb-3">
                          {selectedLicenseImages.map((img, index) => (
                            <div
                              key={index}
                              className="col-md-1 d-flex flex-column align-items-center"
                            >
                              <div>
                                <Link to={img.preview} target="_blank">
                                  <img
                                    style={{
                                      maxWidth: "80px",
                                      maxHeight: "80px",
                                    }}
                                    src={FileImg}
                                    alt=""
                                  />
                                </Link>
                              </div>
                              <div>
                                <Link
                                  to=""
                                  className="delete-btn"
                                  onClick={() => {
                                    removeImage(
                                      index,
                                      setFieldValue,
                                      img.file.id ?? null
                                    );
                                  }}
                                >
                                  <img src={TrashImg} />
                                </Link>
                              </div>
                            </div>
                          ))}
                          {selectedImages.map((img, index) => (
                            <div
                              key={index}
                              className="col-md-1 d-flex flex-column align-items-center"
                            >
                              <div>
                                <Link to={img.preview} target="_blank">
                                  <img
                                    style={{
                                      maxWidth: "80px",
                                      maxHeight: "80px",
                                    }}
                                    src={FileImg}
                                    alt=""
                                  />
                                </Link>
                              </div>
                              <div>
                                <Link
                                  to=""
                                  className="delete-btn"
                                  onClick={() => {
                                    removeImage(index, setFieldValue);
                                  }}
                                >
                                  <img src={TrashImg} />
                                </Link>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="form-group">
                          <h4>Payment Types Accepted</h4>
                          <div className="choosemiles-list">
                            <ul>
                              <li>
                                <div className="ceradio1">
                                  <Field
                                    type="radio"
                                    name="payment_accepted_type"
                                    id="FirstPay"
                                    value="Private Pay"
                                  />
                                  <label for="FirstPay">
                                    <span className="checkbox-text">
                                      {" "}
                                      Private Pay
                                    </span>
                                  </label>
                                </div>
                              </li>
                              <li>
                                <div className="ceradio1">
                                  <Field
                                    type="radio"
                                    name="payment_accepted_type"
                                    id="SecondPay"
                                    value="Debit Card"
                                  />
                                  <label for="SecondPay">
                                    <span className="checkbox-text">
                                      Debit Card
                                    </span>
                                  </label>
                                </div>
                              </li>

                              <li>
                                <div className="ceradio1">
                                  <Field
                                    type="radio"
                                    name="payment_accepted_type"
                                    id="ThirdPay"
                                    value="Insurance"
                                  />
                                  <label for="ThirdPay">
                                    <span className="checkbox-text">
                                      Insurance
                                    </span>
                                  </label>
                                </div>
                              </li>

                              <li>
                                <div className="ceradio1">
                                  <Field
                                    type="radio"
                                    name="payment_accepted_type"
                                    id="FourthPay"
                                    value="Stripe"
                                  />
                                  <label for="FourthPay">
                                    <span className="checkbox-text">
                                      Stripe
                                    </span>
                                  </label>
                                </div>
                              </li>

                              <li>
                                <div className="ceradio1">
                                  <Field
                                    type="radio"
                                    name="payment_accepted_type"
                                    id="FifthPay"
                                    value="Medicare/Medicaid"
                                  />
                                  <label for="FifthPay">
                                    <span className="checkbox-text">
                                      Medicare/Medicaid
                                    </span>
                                  </label>
                                </div>
                              </li>
                            </ul>
                            <ErrorMessage
                              name="payment_accepted_type"
                              component="div"
                              className="alert alert-danger"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="form-group">
                          <h4>Services Description</h4>
                          <Field
                            type="text"
                            as="textarea"
                            className="form-control"
                            name="description"
                            placeholder="Services Description"
                          />
                          <ErrorMessage
                            name="description"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>

                      <div className="form-group text-end">
                        <button
                          type="button"
                          onClick={() => {
                            setEdit({
                              status: false,
                              id: null,
                            });
                          }}
                          className="btn btn-re me-2"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn btn-gr me-2"
                          data-bs-dismiss="modal"
                        >
                          Update
                        </button>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </ModalBody>
        </div>
      </Modal>

      <Modal
        show={deleteAcc}
        onHide={() => {
          setDeleteAcc(false);
        }}
        className="cc-modal-form"
      >
        <div className="modal-content">
          <ModalBody className="">
            <div className="add-items d-flex row">
              <div className="deleteaccount-Img">
                <img src={deleteaccountImg} />
              </div>
              <div className="deleteaccount-text mb-4">
                <h5 className="text-center pb-0">Delete Account</h5>
                <p className="text-center">
                  This action can't be undone. Do you really want to delete your
                  account ?
                </p>
              </div>
              <div className="form-group text-center mb-2">
                <button
                  type="button"
                  onClick={() => setDeleteAcc(false)}
                  className="btn-wh-re me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn-re"
                  data-bs-dismiss="modal"
                  onClick={() => deleteAccount()}
                >
                  Yes! Delete
                </button>
              </div>
            </div>
          </ModalBody>
        </div>
      </Modal>

      <Modal
        show={editImg}
        onHide={() => {
          setEditImg(false);
        }}
        className=""
      >
        <div className="modal-content">
          <ModalHeader>
            <h5 className="mb-0">Edit Profile Image</h5>
          </ModalHeader>
          <ModalBody className="">
            <div className="add-items d-flex row">
              <Formik
                initialValues={initialValuesImg}
                validateOnChange={true}
                validationSchema={validationSchemaImg}
                onSubmit={updateProfileImg}
              >
                {({ setFieldValue }) => (
                  <Form>
                    <div className="form-group">
                      <Field name="image">
                        {({ field, form }) => (
                          <input
                            type="file"
                            accept="image/*"
                            className="form-control"
                            onChange={(event) =>
                              setFieldValue(
                                "image",
                                event.currentTarget.files[0]
                              )
                            }
                          />
                        )}
                      </Field>
                      <ErrorMessage
                        name="image"
                        component="div"
                        className="alert alert-danger"
                      />
                    </div>
                    <div className="form-group text-end">
                      <button
                        type="button"
                        onClick={() => {
                          setEditImg(false);
                        }}
                        className="btn btn-re me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-gr me-2"
                        data-bs-dismiss="modal"
                      >
                        Update
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </ModalBody>
        </div>
      </Modal>
    </>
  );
};

export default Page;
